import { compose, mdsWidget } from 'dojo/_base/declare';
import lang from 'dojo/_base/lang';
import domConstructTyped from 'dojo/dom-construct';
import domStyle from 'dojo/dom-style';
import domClass from 'dojo/dom-class';
import RequestManager from 'more/RequestManager';
import on from 'dojo/on';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import GenericDialog from '../../../../moreCore/UI/GenericDialog/GenericDialog';
// NOTE (JS2TS): the runtime base is AgendaViewBase (see @declare below); the TS interface extends _WidgetBaseSP
// instead because AgendaViewBase declares private members that would clash with this class's public fields.
// The `[key: string]: any` index signature already exposes all inherited members as any.
import Standby from 'dojox/widget/Standby';
import AgendaViewBase from '../../../AgendaViewBase/AgendaViewBase';
import MyBookingsForm from './MyBookingsForm';
import SelectBox from '../../../../moreCore/UI/SelectBox/SelectBox';
import ResourcePicker from '../../../../moreCore/UI/ResourcePicker/ResourcePicker';
import template from './MyBookings.html?raw';
// Template-only widget (used via data-dojo-type in MyBookings.html, not as a value in code) → bare import.
import "../../../../moreCore/UI/DateInput/DateInput";
// NOTE (JS2TS): base is AgendaViewBase; dropped unused dijit _TemplatedMixin/_WidgetsInTemplateMixin/_WidgetBase
// (already mixed into AgendaViewBase). Original imported AgendaViewBase via the WRONG path
// "WidgetCollection/JDM/AgendaViewBase/AgendaViewBase" (there is no JDM/ segment) — repointed to the real file.
// DOM-heavy → dom-construct aliased.
const domConstruct: any = domConstructTyped;

class MyBookings extends compose(AgendaViewBase<any>) {
    [key: string]: any;

    templateString: any = template;
    title: any = HTMLTitleElement;

    bookingForm: any = null;

    itemTableParams: any = { widgetName: "vechicleBookingTable", sContainerNodeName: "resultContainer" };
    entityListAttributeName = "items";
    tableEntityPath = "Entity";
    loadFilterDatatUrl = "";
    loadFilterOptionsUrl = "";

    constructor() {
        super(...(arguments as unknown as []));
        this.templateString = template;
    }

    itemTable_formatterFunction(cell: any): any {
        var node = cell.contentnode;
        var entity = cell.entity;
        var colName = cell.name;
        var value = cell.value;
        switch (colName) {
            case "date":
                var dateFrom = entity["date_start"];
                var dateTo = entity["date_end"];
                if (dateFrom.slice(5, 7) == dateTo.slice(5, 7) && dateFrom.slice(8, 10) == dateTo.slice(8, 10)) {
                    var sYear = dateFrom.slice(0, 4);
                    var sMonth = dateFrom.slice(5, 7);
                    var sDay = dateFrom.slice(8, 10);
                    var sHourFrom = dateFrom.slice(11, 13);
                    var sHourTo = dateTo.slice(11, 13);
                    var sMinuteFrom = dateFrom.slice(14, 16);
                    var sMinuteTo = dateTo.slice(14, 16);
                    node.innerHTML = sHourFrom + ":" + sMinuteFrom + " - " + sHourTo + ":" + sMinuteTo;
                }
                else {
                    node.innerHTML = this.convertISOStringDateToLocalString(dateFrom) + " - " + this.convertISOStringDateToLocalString(dateTo);
                }

                return true;
                break;

            case "actions":
                //node.parentNode.addEventListener("click", (event) => { event.preventDefault(); })
                //on(node.parentNode, "click", (event) => { event.preventDefault(); });
                node.innerHTML = "";

                let dateStart = new Date(entity.date_start);
                let dateEnd = new Date(entity.date_end);
                let now = new Date();

                // Achtung: VehicleBookingEditor darf auch vergangene Termine stornieren/nachbearbeiten.
                // User dürfen ihre eigenen Buchungen auch immer angreifen, auch nachträglich.
                //console.log(entity.ref_booker.ID == window.sessionInfo.sessionData.CurrentEmployeeId, this.hasUserRole("VehicleManage"))
                if ((/*dateEnd.valueOf() < now.valueOf() &&*/ entity.ref_booker.ID == (window as any).sessionInfo.sessionData.CurrentEmployeeId) ||
                    this.hasUserRole("VehicleBookingEditor") &&
                    entity.ref_booking_status.Name != "storniert") {

                    var editBtn = domConstruct.create("button", {
                        innerHTML: "B",
                        class: "mds-button-base round mds-border w3-green mds-hover-bright",
                        style: "display: block; min-width: 25px; margin-left: 10px; cursor: pointer;",
                        title: "Bearbeiten",
                    }, node);
                    on(editBtn, "click", lang.hitch(this, this._onClick_Button_Edit, entity));

                    var stornoBtn = domConstruct.create("button", {
                        innerHTML: "S",
                        class: "mds-button-base round mds-border w3-red mds-hover-bright",
                        style: "display: block; min-width: 25px; margin-left: 10px; cursor: pointer;",
                        title: "Stornieren",
                    }, node);
                    on(stornoBtn, "click", lang.hitch(this, this._onClick_Button_Storno, entity));

                    domClass.add(node, "flex_row");

                }

                return true;

                break;
            default:
                return false;
        }

        return false;
    }



    initAgendaView(): void {
        //console.log("window", window.sessionInfo.sessionData.CurrentEmployeeId)
        this.containerNodeName = this.itemTableParams.sContainerNodeName

        //on(this, "agendaViewLoaded", lang.hitch(this, this._modifiyAgendaView));

        this.setupAgendaView(
            "VehicleBooking/GetFilterpanelOptions",
            "VehicleBooking/GetAgendaView",
            lang.hitch(this, this.itemClickFunction),
            lang.hitch(this, this.itemTable_formatterFunction),
            null,
            lang.hitch(this, this._onDateChange_Custom)
        );
    }

    _getCarPoolData(): void {
        var requestManager = new RequestManager();
        requestManager.post(
            window.appRoot + "VehicleBooking/GetCarPoolData", {},
            lang.hitch(this, "_onGetCarPoolData_Response"),
            lang.hitch(this, "_onGetCarPoolData_Error")
        );
    }



    _onGetCarPoolData_Response(response: any): void {
        this.carPoolData = response
    }

    _onGetCarPoolData_Error(err: any): void {
        console.error("GetBookingDetails", err.Message);
    }

    _processCarPoolValues(): void {
        if (!this.carPoolData) {
            window.setTimeout(lang.hitch(this, this._processCarPoolValues), 1000);
            return;
        }
        this._data_SelectionValues = this.carPoolData;

        for (let entity of this._data_SelectionValues) {
            this.carPoolSelect.addOption(entity.ID, entity.name, true);
        }

        this.carPoolSelect.setLabel("Fuhrpark");

        this.carPoolSelect.setBlankOption(null, "Bitte w&auml;hlen...");

        this.carPoolSelect.constructOptions();
        this.carPoolSelect.startup();
    }

    _onDateChange_Custom(selectedEntries: any, selectedDates: any): void {

        var selectedDate = null;
        if (selectedDates && selectedDates.length) {
            selectedDate = selectedDates[0];
        }
        else {
        }

        this.inputBookingDate.setValue(selectedDate);
    }
    protected createAgendaView(): any {
        super.createAgendaView.apply(this, arguments as any);
        this._modifiyAgendaView();
    }
    _modifiyAgendaView(): void {


        /*
        this.agendaView.datePicker.callback = lang.hitch(this, this._agendaViewDatePickerCallback);

        //this.agendaView.datePicker.allowPast = false;
        this.agendaView.groupingParameter = "ref_vt_service.description";
        this.agendaView.groupingEnabled = true;
        */


        this.carPoolSelect = new SelectBox();
        this._processCarPoolValues();
        this.carPoolSelect.placeAt(this.vehiclePoolContainer);


        var imgContainer = domConstruct.create("div", { class: "flex_row_center justify w3-block" }, this.domNode, "first")

        domConstruct.create("img", {
            src: "../Content/img/logo_jdm.jpg", style: "height: 5ch"
        }, imgContainer, "first")
    }

    _onClick_NewBooking(evt?: any): void {

        let poolvalue = this.carPoolSelect.getValue();
        if (poolvalue == "null") poolvalue = null;
        let dateValue = this.inputBookingDate.getValue();

        domClass.toggle(this.vehiclePoolContainer, "w3-pale-red mds-shake", !poolvalue);
        domClass.toggle(this.dateContainer, "w3-pale-red mds-shake", !dateValue);

        setTimeout(lang.hitch(this, domClass.remove, this.dateContainer, "mds-shake"), 2000);
        setTimeout(lang.hitch(this, domClass.remove, this.vehiclePoolContainer, "mds-shake"), 2000);

        if (!poolvalue || !dateValue) return;

        this._createNewBooking();
    }

    /*
    _modifiyAgendaView: function () {
        if (!this.agendaView) {
            console.log("filterContainer undefined")
            return;
        }

        this.agendaView.datePicker.callback = lang.hitch(this, this._agendaViewDatePickerCallback);

        //this.agendaView.datePicker.allowPast = false;
        this.agendaView.groupingParameter = "ref_vt_service.description";
        this.agendaView.groupingEnabled = true;


        //this.bookingHintMessage = domConstruct.create("div", { className: "w3-center w3-yellow w3-large", style: "cursor: default" }, this.agendaView.filterContainer.parentNode, "first")
        //domConstruct.create("span", { innerHTML: "F&uumlr neue Buchung Fuhrpark und Datum w&aumlhlen..." }, this.bookingHintMessage);


        this.carPoolSelect = new SelectBox();
        this._processCarPoolValues();
        this.carPoolSelect.placeAt(this.agendaView.filterContainer);
        domStyle.set(this.carPoolSelect.domNode, "width", "160px")

        this.addNewBookingButton = domConstruct.create("button", {
            innerHTML: "<i class='fas fa-plus'></i> neue Buchung",
            className: "mds-button-base round mds-green mds-hover-dark w3-disabled w3-margin-top w3-right",
        }, this.agendaView.filterContainer)
        on(this.addNewBookingButton, "click", lang.hitch(this, this._createNewBooking));
},


    _agendaViewDatePickerCallback: function (responseType) {
        var date = new Date(this.agendaView.datePicker.getValue());
        var dateOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        domConstruct.destroy(this.currentDateInfo)
        switch (responseType) {
            case "add":
                this.agendaView.setData(this.resultList);
                this.currentDateInfo = domConstruct.create("h2", { innerHTML: date.toLocaleDateString("de-DE", dateOptions), className: "w3-center w3-padding-0" }, this.agendaView.filterContainer.parentNode, "first")
                break;
        }
    },
        */
    _createNewBooking(): void {
        this.loadTimeslots();
    }

    itemClickFunction(row: any): void {
        this.StandbyStart();

        var entity = row.rowGroup.entity
        var bookingId = entity.ID;
        var url = window.appRoot + "JDM/GetBookingDetails";
        if (!bookingId) alert("no bookingId!");
        this.RequestManager.post(
            url,
            {
                ID: bookingId
            },
            lang.hitch(this, "_onLoadVehicleBookingDetailsResponse"),
            lang.hitch(this, "_onLoadVehicleBookingDetailsError"),
            false // sync
        );
    }

    _onLoadVehicleBookingDetailsResponse(response: any): void {

        this.showBookingInfo(response);
        this.StandbyStop();
    }

    _onLoadVehicleBookingDetailsError(err: any): void {
        console.error("GetBookingDetails", err.Message);
    }

    showBookingInfo(booking: any): void {

        this.bookingDlg = new GenericDialog();
        var bookingForm = new MyBookingsForm();

        domClass.add(this.bookingDlg.textNode, "overflow-visible");

        this.bookingDlg.showActionContainer(true);
        this.bookingDlg.hideSubtitleNode(true);
        this.bookingDlg._setTopCloseBtnAttr(true);
        this.bookingDlg._setCloseBtnAttr(true);
        this.bookingDlg._setHeaderAttr(booking.dispname);

        bookingForm._setValues(booking);
        this.bookingDlg.addNodeToContent(bookingForm.domNode, "first");
        this.bookingDlg.show();
    }



    _onClick_Button_Edit(entity: any, evt: any): void {
        evt.stopPropagation();

        var dlg: any = new GenericDialog();
        var div = domConstruct.create("div", { className: "w3-center w3-border w3-round w3-border-red w3-padding w3-card" });
        domConstruct.create("span", { innerHTML: "<b><h3>Bestehende Buchung stornieren und Zeitraum neu w&auml;hlen?</h3>" + entity.dispname + "</b>" }, div)

        dlg.callback = lang.hitch(this, this._onConfirmEditDialogCallback, entity, dlg);

        dlg._setHeaderAttr(entity.dispname);
        dlg.addNodeToContent(div);
        //dlg._onClick_Button_YES = lang.hitch(this, this._stornoBooking, entity, dlg)
        dlg._setYesBtnAttr(true);

        dlg._setNoBtnAttr(true);

        dlg.show();

    }

    _onConfirmEditDialogCallback(entity: any, dlg: any, responseType: any): void {
        switch (responseType) {
            case 2:
                this._editBooking(entity);
                dlg.close();
                break;
        }
    }

    _editBooking(entity: any): void {
        this.StandbyStart();
        var data = {
            "targetDate": entity.date_start,
            "vehicleServiceId": entity.ref_vt_service.ID,
            "bookingId": entity.ID
        }
        let url = window.appRoot + "JDM/EditVehicleBooking";
        this.StandbyStart(this.resourcePickerContainer);
        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onEditVehicleBookingResponse),
            lang.hitch(this, this._onEditVehicleBookingError),
            false // sync
        );
    }

    _onEditVehicleBookingResponse(response: any): void {
        this.StandbyStop();
        this.loadData();
        this._showTimeslotPicker(response)
    }

    _onEditVehicleBookingError(err: any): void {
        console.error("EditVehicleBooking", err.Message);
    }

    _onClick_Button_Storno(entity: any, evt: any): void {
        evt.stopPropagation();

        let dateStart = new Date(entity.date_start);
        let now = new Date();
        //if (dateStart.valueOf() < now.valueOf()) {
        //    alert("Vergangene Buchung kann nicht storniert werden!")
        //    return;
        //}

        var dlg: any = new GenericDialog();
        var div = domConstruct.create("div", { className: "w3-center w3-border w3-round w3-border-red w3-padding w3-card" });
        domConstruct.create("span", { innerHTML: "<b><h3>Buchung stornieren?</h3>" + entity.dispname + "</b>" }, div)

        dlg.callback = lang.hitch(this, this._onStornoBookingCallback, entity, dlg);

        dlg._setHeaderAttr(entity.dispname);
        dlg.addNodeToContent(div);
        //dlg._onClick_Button_YES = lang.hitch(this, this._stornoBooking, entity, dlg)
        dlg._setYesBtnAttr(true);

        dlg._setNoBtnAttr(true);

        dlg.show();
    }

    _onStornoBookingCallback(entity: any, dlg: any, response: any): void {
        if (response == 2) {
            this._stornoBooking(entity, dlg);
        }
    }

    _stornoBooking(entity: any, dlg: any): void {
        dlg.close();

        let url = window.appRoot + "JDM/StornoVehicleBooking";
        this.StandbyStart();
        this.RequestManager.post(
            url,
            {
                bookingId: entity.ID
            },
            lang.hitch(this, this._onStornoVehicleBookingResponse, dlg),
            lang.hitch(this, this._onStornoVehicleBookingError),
            false // sync
        );
    }

    _onStornoVehicleBookingResponse(dlg: any, response?: any): void {
        this.loadData();
    }

    _onStornoVehicleBookingError(err: any): void {
        alert("Storno fehlgeschlagen: " + err.Message);
    }

    loadTimeslots(): void {
        let date = this.inputBookingDate.getValue();
        if (date == null) {
            var dlg: any = new GenericDialog();
            var div = domConstruct.create("div", { className: "w3-center w3-border w3-round w3-border-red w3-padding w3-card" });
            domConstruct.create("span", { innerHTML: "<b><h3>Kein Datum gew&auml;hlt!</b>" }, div)
            dlg._setTopCloseBtnAttr(true);
            dlg._setCloseBtnAttr(true);
            dlg._setHeaderAttr("ung&uuml;ltiges Datum!");
            dlg.addNodeToContent(div);
            dlg.show();
            return;
        }

        var selectedDate = new Date(date.getTime() - (date.getTimezoneOffset() * 60000))
        var today = new Date();
        today.setHours(selectedDate.getHours(), 0, 0, 0)

        if (today > selectedDate) {
            var dlg: any = new GenericDialog();
            var div = domConstruct.create("div", { className: "w3-center w3-border w3-round w3-border-red w3-padding w3-card" });
            domConstruct.create("span", { innerHTML: "<b><h3>Es k&ouml;nnen keine Buchungen f&uuml;r die Vergangenheit angelegt werden!</b>" }, div)
            dlg._setTopCloseBtnAttr(true);
            dlg._setCloseBtnAttr(true);
            dlg._setHeaderAttr("ung&uuml;ltiges Datum!");
            dlg.addNodeToContent(div);
            dlg.show();
            return;
        }

        if (!date) {
            alert("no date!");
        }

        var data = {
            "targetDate": this.dateToLocalISOString(selectedDate),
            "carpoolID": this.carPoolSelect.getValue(),
        };

        let url = window.appRoot + "JDM/GetVehicleTimeslots";
        this.StandbyStart(this.resourcePickerContainer);
        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(data)
            },
            lang.hitch(this, this._onLoadTimeSlotsResponse),
            lang.hitch(this, this._onLoadTimeslotsError),
            false // sync
        );
    }

    _onLoadTimeSlotsResponse(response: any): void {
        this._showTimeslotPicker(response)
        this.StandbyStop();
    }

    _showTimeslotPicker(response: any): void {
        let date = this.inputBookingDate.getValue();
        var dateOptions: any = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };
        var dlg: any = new GenericDialog();
        this.routeResourcesRegistry = response.groups;
        //dlg.enableContentOverflow(true);
        dlg.showActionContainer(true);
        dlg.hideSubtitleNode(true);
        dlg._setTopCloseBtnAttr(true);
        dlg._setCloseBtnAttr(true);
        dlg._setHeaderAttr("neue Buchung f&uuml;r " + date.toLocaleDateString("de-DE", dateOptions));

        var container = domConstruct.create("div", { style: "max-height: 45ch; overflow: auto" })

        this.textarea = domConstruct.create("textarea", { className: "w3-border w3-block w3-margin-top", placeholder: "Anmerkung..." })

        //this.UiModder.domConstruct.empty(this.resourcePickerContainer);
        this.resourcePicker = new ResourcePicker();
        this.resourcePicker.setConfiguration(response);
        this.resourcePicker.setTooltipClickFct(lang.hitch(this, this._onClick_ResourceTooltip));
        domStyle.set(this.resourcePicker.tableContainer, "width", "unset")
        //this.resourcePicker.setBaseUnits(3, 1);
        on(this.resourcePicker, "change", lang.hitch(this, this._slotsSelected, dlg))
        dlg.setUserdefinedButton("Buchen", "fas fa-save", lang.hitch(this, this._createBookingForm), true);
        //domClass.add(dlg.btnUserdefined, 'w3-disabled');
        dlg.disableButton("default_userdefined");
        this.resourcePicker.placeAt(container, "first")


        dlg.addNodeToContent(container);
        dlg.addNodeToContent(this.textarea);

        dlg.show();
    }

    _onClick_ResourceTooltip(resource: any, content: any): void {
        //console.debug("_onClick_RouteResourceTooltip", resource, content, this.routeResourcesRegistry);
        let dlg: any = new GenericDialog();
        dlg._setHeaderAttr(resource.label);
        dlg.setCloseOnEscape(true);
        dlg._setTopCloseBtnAttr(true);
        dlg._setCloseBtnAttr(true);
        dlg.setCloseOnEnter(false);
        dlg._setContentAttr(resource.tooltip);

        dlg.show();
    }

    _slotsSelected(dlg: any, data: any): void {
        //domClass.toggle(dlg.btnUserdefined, 'w3-disabled', data.length == 0);
        dlg.enableButton("default_userdefined", data.length > 0);
    }

    _createBookingForm(data: any): void {
        //console.log("test", this.resourcePicker.items.filter(data => this.resourcePicker.getValue().includes(data.value)), this.textarea.value);

        var selectedNodes = this.resourcePicker.items.filter((data: any) => this.resourcePicker.getValue().includes(data.value));

        // JS2TS: original used [...map.values()]; Array.from is the ES5-target-safe equivalent (avoids --downlevelIteration).
        var uniqueVehicleIds = Array.from(new Map(selectedNodes.map((item: any) =>
            [item["groupValue"], item["groupValue"]])).values());

        if (uniqueVehicleIds.length > 1) {
            alert("ungültige Auswahl!");
            return;
        } else if (uniqueVehicleIds.length == 1) {
            var vehicleId = uniqueVehicleIds[0];
        }

        var jsonData = {
            "serviceVehicleId": vehicleId,
            "timeslots": this.resourcePicker.getValue(),
            "note": this.textarea.value,
        }

        //let url = window.appRoot + "XY/GetConfiguration";
        let url = window.appRoot + "JDM/CreateNewVehicleBooking";
        this.StandbyStart();
        this.RequestManager.post(
            url,
            {
                jsonData: JSON.stringify(jsonData)
            },
            lang.hitch(this, this._onCreateNewVehicleBookingResponse),
            lang.hitch(this, this._onCreateNewVehicleBookingError),
            false // sync
        );
    }

    _onCreateNewVehicleBookingResponse(response: any): void {
        this.StandbyStop();
        this.showBookingInfo(response);
        this.loadData();
    }
    _onCreateNewVehicleBookingError(err: any): void {

    }

    _onLoadTimeslotsError(error: any): void {
        this.StandbyStop();
        alert(error.Message);
    }

    convertISOStringDateToLocalString(isoString: any): any {
        //2021-03-15T10:00:00
        var sYear = isoString.slice(0, 4);
        var sMonth = isoString.slice(5, 7);
        var sDay = isoString.slice(8, 10);
        var sHour = isoString.slice(11, 13);
        var sMinute = isoString.slice(14, 16);
        return `${sDay}.${sMonth}.${sYear}, ${sHour}:${sMinute}`;
    }

    //constructor: function (params) {
    //    lang.mixin(this, params);
    //},

    buildRendering(): void {
        super.buildRendering.apply(this, arguments as any);
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.standby = new Standby();
        document.body.appendChild(this.standby.domNode);
        this.standby.startup();

        domClass.add(document.body, "claro");
        this._getCarPoolData();

        this.initAgendaView();

    }

    startup(): void {
        this.setHeading(this.translations["myBookings_title"]);
        super.startup.apply(this, arguments as any);
    }


}
MyBookings.prototype.declaredClass = 'WidgetCollection.VehicleBooking.MyBookings';

export default mdsWidget(MyBookings);
